import { FacilityAssetsData } from "../../components/FacilityAssets/FacilityAssetsWithStoreWithData"
import AllAssetsReport from "."

const AllAssetsReportWithData = FacilityAssetsData(AllAssetsReport)

export default AllAssetsReportWithData
